module.exports = __webpack_public_path__ + "media/images/icons/share-white-32f0d66c339d73e5330e256de8855227.svg";